var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-launcher-links", {
    attrs: { "is-disabled": _vm.isSavingSettings },
    on: {
      "go-to": function ($event) {
        return _vm.goToAppBundle({ app: $event })
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }